<template>
    <div class="col-sm-12 list-content-item mb-2">
        <div class="row">
            <div class="col-auto image-container">
                <avatar-badge :src="displayImage" :raised="false" :size="100"></avatar-badge>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-lg-9">
                        <h2 class="title" v-text="shop.name"></h2>
                    </div>
                    <div class="col-lg-3 text-lg-right text-left mt-sm--2 mt-lg-0">
                        PHP<span class="text-lg" v-text="displayedPrice"></span>
                    </div>
                </div>
                <div class="description">Booking No: {{ booking.code }}</div>
                <div class="description">Appointment on {{ displayedAppointmentDatetime }}</div>
                <div class="description text-capitalize" v-text="displayedStatus"></div>
                <div class="text-right">
                    <router-link :to="bookingLink" v-slot="{ href, navigate }">
                        <a :href="href" @click="navigate" class="btn btn-sm btn-warning">
                            <i class="fa fa-eye mr-1"></i> View Details
                        </a>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import { resource, pageRoute } from "@utils/network";

export default {
    name: "BookingListItem",

    computed: {
        bookingLink() {
            return {name: 'Booking Page', params: { id: this.booking.id }};
        },
        shop() {
            return this.booking.shop || {};
        },
        displayImage() {
            return this.shop.display_image || resource("images/placeholders/avatar.jpg");
        },
        displayedPrice() {
            return parseFloat(this.booking.total_cost || 0).toFixed(2);
        },
        displayedAppointmentDatetime() {
            return this.booking.appointment_datetime
                ? moment(this.booking.appointment_datetime).format("MMMM DD, YYYY hh:mm A")
                : moment().format("MMMM DD, YYYY hh:mm A");
        },
        displayedStatus() {
            let status = this.booking.status || "Loading...";
            
            return status.replaceAll("_", " ");
        },
    },
    
    props: {
        booking: [Object],
    },

    mounted() {

    }
}
</script>